// utils.js
import React from 'react';

/**
 * Format text with bold markdown syntax
 */
export const formatText = (text) => {
  return text.split(/\*\*(.*?)\*\*/g).map((part, index) => (index % 2 === 1 ? <strong key={index}>{part}</strong> : part));
};

/**
 * Generate random session ID
 */
export const generateSessionId = () => {
  const numbers = '0123456789';
  const length = 8;
  let randomId = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * numbers.length);
    randomId += numbers.charAt(randomIndex);
  }

  return randomId;
};

/**
 * Find corresponding prompt for a bot message
 */
export const findCorrespondingPrompt = (chatData, botMessageIndex) => {
  for (let i = botMessageIndex - 1; i >= 0; i--) {
    if (chatData[i]?.prmt) {
      return chatData[i].prmt;
    }
  }
  return null;
};

/**
 * Find prompt index
 */
export const findPromptIndex = (chatData, botMessageIndex) => {
  for (let i = botMessageIndex - 1; i >= 0; i--) {
    if (chatData[i]?.prmt) {
      return i;
    }
  }
  return null;
};

/**
 * Copy text to clipboard
 */
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
};

/**
 * Get IDs to delete from chat data
 */
export const getIdsToDelete = (chatData, startIndex) => {
  return chatData
    .slice(startIndex)
    .map((msg) => msg?.id)
    .filter(Boolean);
};

/**
 * Check if device is mobile
 */
export const isMobileDevice = () => {
  return window.innerWidth <= 768;
};

/**
 * Parse message lines for display
 */
export const MessageComponent = ({ message, widgetDetails }) => {
  const lines = message.split('\n');

  return (
    <>
      {lines.map((line, index) => (
        <p
          key={index}
          className='m-0 outfit-regular'
          style={{
            color: widgetDetails?.text_color_bubble,
            fontSize: `${widgetDetails?.bubble_text_size}px`,
          }}
        >
          {line || 'Hey,'}
        </p>
      ))}
    </>
  );
};
